import { operations } from '@luxuryescapes/contract-cart/server';

export enum CartType {
  PENDING = 'pending',
  COMPLETED = 'completed',
  PURCHASED = 'purchased',
  ABANDONED = 'abandoned',
}

export type CartRawItem = NonNullable<
  operations['getCartsByUser']['responses'][200]['content']['application/json']['result']
>[number]['rawItems'][number];

export interface Cart {
  transactionKey: string;
  createdAt: number | null;
  rawItems: Array<CartRawItem>;
  type: CartType | null; // This is the cart status
  // Other fields are present, treat them as unknown.
  [key: string]: unknown;
}

export interface GetUserCartsParams {
  brand: string;
  sortDir: 'ASC' | 'DESC';
  page: number;
  limit: number;
  cartId?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  statuses?: Array<CartType>;
}

export interface GetUserCartsResponse {
  status: number;
  total: number;
  count: number;
  result: Array<Cart>;
}
